export default __webpack_public_path__ + "static/media/Pistol_3.189e98ab.png";